module.exports = __webpack_public_path__ + "img/waybill_intrduction.ead165d0.jpg";